import { Context, FunctionComponent, useState } from 'react';

import type { GraphqlClient } from './data-client';
import { gqlClientContext, useGqlClient } from './gql-client-context';
import { createErrorLink } from './link/error';
import type { TReporting } from './types';

export { useGqlClient };

export interface IGqlClientDataProviderProps {
  client: GraphqlClient;
  reporting?: TReporting;
}

const DataProvider: FunctionComponent<
  React.PropsWithChildren<IGqlClientDataProviderProps>
> = ({ children, client, reporting }) => {
  const [linkInitiated, setLinkInitiated] = useState(false);
  if (!linkInitiated) {
    client.setLink(createErrorLink(reporting).concat(client.link));
    setLinkInitiated(true);
  }
  return (
    <gqlClientContext.Provider value={client}>
      {children}
    </gqlClientContext.Provider>
  );
};

export const GqlClientProvider: typeof DataProvider & {
  context: typeof gqlClientContext;
} = DataProvider as FunctionComponent<
  React.PropsWithChildren<IGqlClientDataProviderProps>
> & {
  context: Context<GraphqlClient>;
};

GqlClientProvider.context = gqlClientContext;
GqlClientProvider.displayName = 'GqlClientProvider';
